import { styled } from '@mui/material/styles';
import { Show } from 'shared/react-admin/Show/Show';

export const ShowStyled = styled(Show)(({ theme }) => ({
  '& .RaShow-main': {
    margin: 0,
  },
  '& .RaShow-card': {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '8px',
  },
}));
